import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store/store";
import {emptyFiduciarySummary, FiduciarySummary} from "../model/EstateFlowchartTypes";

export type Fiduciaries = FiduciarySummary;

const fiduciarySlice = createSlice({
    name: "fiduciary",
    initialState: emptyFiduciarySummary,
    reducers: {
        setFiduciarySummaryState: (_state, action: PayloadAction<FiduciarySummary>) => action.payload,
        resetFiduciarySummaryState: () => (emptyFiduciarySummary),
    }
});

export const getFiduciarySummary = (state: RootState) => state.estateFlowchart.fiduciaries;

export const {
    setFiduciarySummaryState,
    resetFiduciarySummaryState
} = fiduciarySlice.actions

export default fiduciarySlice.reducer;
